module.exports = __webpack_public_path__ + "static/img/wdsjtb1-1.7644e35.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdsjtb1-1.png
// module id = 425
// module chunks = 0